module.exports = __webpack_public_path__ + "media/pro/Phone-66f19a05.png";